import { render, staticRenderFns } from "./ClinicListModule.vue?vue&type=template&id=157274e6&scoped=true&"
import script from "./ClinicListModule.vue?vue&type=script&lang=js&"
export * from "./ClinicListModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157274e6",
  null
  
)

export default component.exports